import type { ImageSourcePropType } from "react-native";
import Box from "../Box";
import EmptyView from "../EmptyView";
import ScrollContainer from "../ScrollContainer";

const DEFAULT_IMAGE_URI =
	"https://services.memorang.com/storage/v1/object/public/memorang-assets/assets/maintenance.png";

export type MaintenanceViewProps = {
	title: string;
	subtitle: string;
	image?: ImageSourcePropType;
	ctaLabel?: string;
	onPressCta?: () => void;
};

const MaintenanceView = ({
	title,
	subtitle,
	image = { uri: DEFAULT_IMAGE_URI },
	ctaLabel,
	onPressCta,
}: MaintenanceViewProps) => (
	<ScrollContainer maxWidth="sm" contentContainerStyle={{ flex: 1 }}>
		<Box justifyContent="center" alignItems="center">
			<EmptyView
				title={title}
				subtitle={subtitle}
				image={image}
				cta={ctaLabel}
				handleAction={onPressCta}
			/>
		</Box>
	</ScrollContainer>
);

export default MaintenanceView;
